
import { defineComponent, ref, onMounted } from 'vue'
import { object } from 'yup'
import { useForm } from 'vee-validate'
import { myValidationSchemaObj } from '@/views/validation'
import { services } from '@/services/services'
import ContentLayout from '@/views/layout/ContentLayout.vue'
import { ResponseTenant } from '@/services/tenantService'
import { callApiWrapper } from '@/views/callApiWrapper'
import ResponseResultAlert from '@/views/components/ResponseResultAlert.vue'

const service = services.tenant

type InputForm = {
  tenantId: string;
}

const validationSchema = object({
  tenantId: myValidationSchemaObj.requiredString
})

export default defineComponent({
  components: {
    ResponseResultAlert,
    ContentLayout
  },
  setup () {
    const isRequestSucceed = ref(false)
    const requestErrorMessage = ref<string | null>(null)
    const tenants = ref<ResponseTenant[]>([])
    const initializing = ref(false)

    const { errors, values, meta, validate } = useForm<InputForm>({
      validationSchema: validationSchema,
      initialValues: {
        tenantId: ''
      }
    })

    onMounted(async () => {
      initializing.value = true
      await callApiWrapper(requestErrorMessage, async () => {
        tenants.value = await service.list()
        tenants.value.forEach(tenant => {
          if (tenant.selected) {
            values.tenantId = tenant.tenantId
          }
        })
      })
      initializing.value = false
      await validate()
    })

    const onClickedRegister = async () => {
      dismissAlert()
      await callApiWrapper(requestErrorMessage, async () => {
        await service.save(values.tenantId)
        isRequestSucceed.value = true
      })
    }

    const dismissAlert = () => {
      isRequestSucceed.value = false
      requestErrorMessage.value = null
    }

    return {
      isRequestSucceed,
      requestErrorMessage,
      initializing,
      tenants,
      errors,
      values,
      meta,
      validate,
      onClickedRegister,
      dismissAlert
    }
  }
})
